import { useQuery } from '@tanstack/react-query'
import { aiStudioService } from '../../service/aiStudio'
import { VideoAPIResponse } from '../../pages/ai-studio/gallery/types'

function useGetGalleryVideos(page: number, limit: number, options?: { enabled?: boolean }) {
  return useQuery<VideoAPIResponse>({
    queryKey: ['gallery-videos', page, limit],
    queryFn: async () => {
      const result = await aiStudioService.getMyVideos(page, limit)
      return result
    },
    staleTime: 5000,
    refetchOnWindowFocus: false,
    enabled: options?.enabled ?? true, // 기본값은 true
  })
}

export default useGetGalleryVideos